export const primaryColor = '#cd0438';
export const darkColor = '#575656';
export const blueColor = '#1573FE';

export const shadow = {
  shadowColor: 'rgba(0,0,0,0.5)',
  shadowOpacity: 1.0,
  elevation: 7,
  shadowRadius: 5,
};

export const styles = {
  largeRoundedBtn: {
    paddingTop: 25,
    paddingBottom: 25,
    borderRadius: 45,
    backgroundColor: primaryColor,
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
  },

  profilePictureCreator: {
    height: 40,
    width: 40,
    borderRadius: 45,
    marginRight: 10,
  },
  profilePictureComments: {
    height: 30,
    width: 30,
    borderRadius: 45,
    marginRight: 10,
  },
  profilePicture: {
    width: 100,
    height: 100,
    borderRadius: 50,
    marginTop: 50,
    alignSelf: 'center',
  },
  navbar: {
    paddingTop: 30,
    height: '100vh',
    backgroundColor: '#101010',
  },
  sidePadding: {
    paddingLeft: 20,
    paddingRight: 20,
  },
  modalBackdrop: {
    position: 'absolute',
    height: '100vh',
    width: '100vw',
    backgroundColor: 'rgba(0,0,0,0.6)',
    top: 0,
    left: 0,
    zIndex: 9,
  },
  modal: {
    backgroundColor: '#fff',
    borderRadius: 5,
    padding: 2,
    maxHeight: '95vh',
    overflowY: 'scroll',
    position: 'relative',
    zIndex: 10,
  },
  regPlate: {
    backgroundColor: '#FFDB1F',
    borderRadius: 5,
    padding: 5,
    paddingLeft: 10,
    paddingRight: 10,
  },
  titleSize: {
    fontSize: 'clamp(2.8rem, 6vw + 0.8rem, 4rem)', // Huge hero
    fontWeight: 700,
    lineHeight: 1.1,
  },
  subheader1Size: {
    fontSize: 'clamp(1.2rem, 2.5vw + 0.5rem, 2.2rem)', // Secondary headline
    fontWeight: 500,
    lineHeight: 1.3,
  },
  subheader2Size: {
    fontSize: 'clamp(1.1rem, 2vw + 0.5rem, 1.5rem)',
    fontWeight: 400,
    lineHeight: 1.4,
  },
  pSize: {
    fontSize: 'clamp(0.9rem, 1vw + 0.25rem, 1.1rem)',
    fontWeight: 300,
    lineHeight: 1.6,
  },
  captionSize: {
    fontSize: 'clamp(0.75rem, 0.8vw + 0.3rem, 0.875rem)',
    fontWeight: 300,
    lineHeight: 1.4,
  },
};
